import React from 'react'
import styled from 'styled-components'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, Scrollbar, A11y } from 'swiper'
SwiperCore.use([Pagination, Scrollbar, A11y])
import { createResource, useResource } from '@/lib/i18n'
import { Trans } from 'react-i18next'
import { Animation, Reveal } from 'react-genie'
import LazyLoad from 'react-lazyload'

const resource = createResource({
  en: {
    mainTitle: 'OUR TEAM',
    title1: 'Ronald Andi Kasim',
    subTitle1: 'President Director of PT Kredit Pintar Indonesia',
    desc1: `Ronny Kasim, CFA is the company's President Director. Ronny has around 30 years experience in risk management, banking, and capital market. Prior to joining Kredit Pintar, he has hold various positions in corporations located in Indonesia, the United States, France, United Arab Emirates, and Singapore including Chairman of Credit Bureau Indonesia (KBIJ), Director of Trusting Social Indonesia, President Director of Pefindo Kredit Biro, President Director of Pemeringkat Efek Indonesia, Project Manager of Moody's, and Lead Business Analyst of First National Bank. Ronnie earned his BSBA in Finance and MBA degrees from Creighton University in the US and Doctoral degree in Leadership & Policy Innovation from Universitas Gadjah Mada. He is also a CFA Charterholder.`,
    title2: 'Wawan Salum',
    subTitle2: 'Commissioner of PT Kredit Pintar Indonesia',
    desc2: `Wawan Salum is the Commissioner of Kredit Pintar Indonesia. With excellent experiences in banking industry for more than 15 years, Wawan Salum was known to occupy various essential positions in several companies, such as Cards Marketing Director in Citi, Consumer Banking Director in HSBC, and Managing Director-Consumer Banking in DBS Bank. With exceptional track records and working experiences, Wawan Salum envisions Kredit Pintar Indonesia to be the company that gives huge contributions in financial inclusion acceleration in Indonesia.`,
    title3: 'Riko Abdurrahman',
    subTitle3: 'Independent Commissioner of PT Kredit Pintar Indonesia',
    desc3: `Riko Abdurrahman is a senior executive with more than 30 years of experience in the banking, consumer finance, and payments industries across Indonesia and the Philippines.<br/>Before taking the role of independent commissioner of PT Kredit Pintar Indonesia, he previously served as President Director and Country Manager of Visa Indonesia, where he led the company's overall business strategy, growth, and stakeholder engagement. During his tenure, Visa significantly expanded its merchant acceptance network, accelerated the adoption of digital payment technologies, and delivered strong business growth while strengthening partnerships with financial institutions, fintech companies, merchants, regulators, and government agencies.<br/>Mr. Abdurrahman also served as Vice Secretary General of the Indonesian Payment System Association (ASPI), contributing to the development of Indonesia's payment ecosystem through collaboration with Bank Indonesia and industry stakeholders on key initiatives related to open banking, payment infrastructure, data security, consumer protection, and regulatory development.<br/>Prior to Visa, he held senior leadership positions including President and Director of Metrobank Card Corporation in the Philippines, Director of TransUnion Philippines, Card Business Director at ANZ Indonesia, and executive roles at ABN AMRO Bank and Citibank.<br/>Mr. Abdurrahman holds an MBA from the Institut Pengembangan Manajemen Indonesia (IPMI), a Master of Science in Civil Engineering from Columbia University, New York, and a Bachelor of Science in Civil Engineering with Distinction from Worcester Polytechnic Institute, Massachusetts, USA.`,
  },
  id: {
    mainTitle: 'TIM KAMI',
    title1: 'Ronald Andi Kasim',
    subTitle1: 'President Direktur PT Kredit Pintar Indonesia',
    desc1: `Ronny Kasim, CFA saat ini menjabat sebagai Direktur Utama perusahaan. Ronny mempunyai pengalaman hampir 30 tahun di dunia manajemen risiko, perbankan, dan pasar modal. Sebelum bergabung di Kredit Pintar, Ronny menjabat berbagai posisi kunci di beberapa perusahaan yang berlokasi di Indonesia, Amerika Serikat, Perancis, Uni Emirat Arab, dan Singapura. Posisi kunci yang pernah diembannya antara lain, Komisaris Utama Credit Bureau Indonesia (KBIJ), Direktur Trusting Social Indonesia, Direktur Utama Pefindo Biro Kredit, Direktur Utama Pemeringkat Efek Indonesia, Project Manager Moody's, dan Lead Business Analyst First National Bank. Ronny mendapatkan gelar BSBA in Finance dan MBA dari Creighton University di Amerika Serikat serta gelar Doktor Kepemimpinan & Inovasi Kebijakan dari Universitas Gadjah Mada. Ronny juga mempunyai sertifikasi CFA.`,
    title2: 'Wawan Salum',
    subTitle2: 'Komisaris PT Kredit Pintar Indonesia',
    desc2: `Wawan Salum merupakan Komisaris Kredit Pintar Indonesia. Dengan pengalaman di dunia perbankan selama lebih dari 15 tahun, Wawan Salum tercatat pernah menduduki jabatan penting dalam perusahaan, seperti Cards Marketing Director di Citi, Consumer Banking Director di HSBC, dan Managing Director-Consumer Banking di DBS Bank. Dengan rekam jejak dan pengalaman kerja yang mumpuni, Wawan Salum memiliki visi untuk membawa Kredit Pintar Indonesia untuk menjadi perusahaan yang mampu memberikan kontribusi besar terhadap percepatan inklusi keuangan di Indonesia.`,
    title3: 'Riko Abdurrahman',
    subTitle3: 'Komisaris Independen PT Kredit Pintar Indonesia',
    desc3: `Riko Abdurrahman adalah seorang eksekutif senior dengan pengalaman lebih dari 30 tahun di industri perbankan, pembiayaan konsumen, dan pembayaran yang mencakup wilayah Indonesia dan Filipina.<br/>Sebelum menjabat sebagai Komisaris Independen PT Kredit Pintar Indonesia, beliau pernah menjabat sebagai Presiden Direktur dan Country Manager Visa Indonesia, di mana beliau memimpin strategi bisnis secara keseluruhan, pertumbuhan, serta hubungan dengan pemangku kepentingan perusahaan. Selama masa jabatannya, Visa secara signifikan memperluas jaringan penerimaan <b>merchant</b>, mempercepat adopsi teknologi pembayaran digital, dan mencatatkan pertumbuhan bisnis yang kuat sembari mempererat kemitraan dengan berbagai lembaga keuangan, perusahaan <b>fintech</b>, <b>merchant</b>, regulator, dan instansi pemerintah.<br/>Beliau juga pernah menjabat sebagai Wakil Sekretaris Jenderal Asosiasi Sistem Pembayaran Indonesia (ASPI), serta berkontribusi dalam pengembangan ekosistem pembayaran Indonesia melalui kerja sama dengan Bank Indonesia dan para pemangku kepentingan industri terkait inisiatif-inisiatif utama seperti <b>open banking</b>, infrastruktur pembayaran, keamanan data, perlindungan konsumen, dan pengembangan regulasi.<br/>Sebelum bergabung dengan Visa, beliau memegang berbagai posisi kepemimpinan senior, termasuk sebagai Presiden dan Direktur Metrobank Card Corporation di Filipina, Direktur TransUnion Filipina, Direktur Bisnis Kartu di ANZ Indonesia, serta posisi eksekutif di ABN AMRO Bank dan Citibank.<br/>Riko Abdurrahman meraih gelar MBA dari Institut Pengembangan Manajemen Indonesia (IPMI), gelar Master of Science di bidang Teknik Sipil dari Columbia University, New York, serta gelar Bachelor of Science di bidang Teknik Sipil dengan predikat <b>Distinction</b> dari Worcester Polytechnic Institute, Massachusetts, Amerika Serikat.`,
  },
})

const IntroduceHook = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()
  const FeatureList = [
    {
      img: '/images/about/about-one.png',
      title: t('title1'),
      subtitle: t('subTitle1'),
      desc: t('desc1'),
    },
    {
      img: '/images/about/about-two.png',
      title: t('title2'),
      subtitle: t('subTitle2'),
      desc: t('desc2'),
    },
    {
      img: '/images/about/about-three.png',
      title: t('title3'),
      subtitle: t('subTitle3'),
      desc: <Trans defaults={t('desc3') as string} components={{ b: <b />, br: <br /> }} />,
    },
  ]
  return (
    <Introduce>
      <div className="main-title">{t('mainTitle')}</div>
      <div className="items" style={{ width: width >= 1000 ? 'auto' : '360px' }}>
        {width >= 1000 ? (
          FeatureList.map((item, index) => (
            <div key={index} className="item">
              <div className="img">
                <Reveal delay={100 + index * 30} animation={Animation.FadeIn}>
                  <LazyLoad>
                    <img src={item.img} alt={item.title} />
                  </LazyLoad>
                </Reveal>
              </div>
              <div className="text-group">
                <div className="title">{item.title}</div>
                <div className="subtitle">{item.subtitle}</div>
                <div className="desc">{item.desc}</div>
              </div>
            </div>
          ))
        ) : (
          <Swiper loop={true} pagination={{ clickable: true }} scrollbar={{ draggable: true }}>
            {FeatureList.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="item">
                  <div className="img">
                    <LazyLoad>
                      <img src={item.img} alt={item.title} />
                    </LazyLoad>
                  </div>
                  <div className="title">{item.title}</div>
                  <div className="subtitle">{item.subtitle}</div>
                  <div className="desc">{item.desc}</div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </Introduce>
  )
}

export default IntroduceHook

const Introduce = styled.div`
  @media only screen and (max-width: 1000px) {
    margin: 48px auto 0;
    text-align: center;
    width: 100%;
    .main-title {
      font-size: 24px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 28px;
      padding-bottom: 24px;
    }
    .items {
      display: flex;
      justify-content: space-between;
      .item {
        margin: 0 auto;
        text-align: left;
        width: 272px;
        .img {
          width: 160px;
          height: 160px;
        }
        .title {
          padding-top: 24px;
          font-size: 18px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #212121;
          line-height: 21px;
        }
        .subtitle {
          font-size: 18px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #1cc812;
          line-height: 21px;
          margin: 8px auto 16px;
          min-height: 42px;
        }
        .desc {
          font-size: 14px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #9e9e9e;
          line-height: 20px;
          margin-bottom: 30px;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    padding: 90px 150px 72px;
    text-align: center;
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    .main-title {
      font-size: 36px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 48px;
      padding-bottom: 48px;
    }
    .items {
      display: grid;
      grid-template-rows: repeat(4, max-content);
      grid-gap: 48px;
      .item {
        display: grid;
        grid-template-columns: auto 1fr;
        grid-gap: 10px;
        text-align: left;
        .img {
          width: 160px;
          height: 160px;
        }
        .text-group {
          .title {
            font-size: 16px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #212121;
            line-height: 24px;
          }
          .subtitle {
            font-size: 18px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #1cc812;
            line-height: 24px;
            width: 90%;
            margin: 8px 0;
          }
          .desc {
            font-size: 14px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #757575;
            line-height: 24px;
          }
        }
      }
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
`
